import DysonSubmarine from '@app/assets/images/products/submarine.png'
import DysonGen5 from '@app/assets/images/products/gen5.png'
import VacuumImgIt from '@app/assets/images/it/banner-vacuums.png'
import langPacks from '@app/lang'
import { parse } from 'date-fns'
import type { Program } from './programs.types'

const today = new Date()

const unieuro: Program = {
  id: 'UNIEURO',
  urlSegment: 'unieuro',
  supportedLanguages: ['en', 'it'],
  defaultLanguage: 'it',
  languagePack: langPacks.unieuro,
  products: [
    { name: 'Dyson Gen5detect™', img: DysonGen5 },
    { name: 'Dyson V15s Submarine™', img: DysonSubmarine },
  ],
  retailers: [
    'Abruzzo',
    'Basilicata',
    'Calabria',
    'Campania',
    'Emilia-Romagna',
    'Friuli-Venezia Giulia',
    'Lazio',
    'Liguria',
    'Lombardia',
    'Marche',
    'Molise',
    'Piemonte',
    'Puglia',
    'Sardegna',
    'Sicilia',
    'Toscana',
    'Trentino Alto Adige',
    'Umbria',
    "Valle d'Aosta",
    'Veneto',
  ],
  startDate: parse('22-04-2024', 'dd-MM-yyyy', new Date()),
  endDate: parse('19-05-2024', 'dd-MM-yyyy', new Date()),
  bannerImg: VacuumImgIt,
  traded_products: [
    { value: 'Dyson' },
    { value: 'Rowenta' },
    { value: 'Hoover' },
    { value: 'Samsung' },
    { value: 'LG' },
    { value: 'Folletto' },
    { value: 'Other', localeKey: 'tradein_q1_option_2' },
  ],
  offer_strategy: 'combined_sku',
  offer_rules: {
    gen5: [
      { with: 'Dyson', value: 150 },
      { with: 'Rowenta', value: 100 },
      { with: 'Hoover', value: 100 },
      { with: 'Samsung', value: 100 },
      { with: 'LG', value: 100 },
      { with: 'Folletto', value: 100 },
      { with: 'Other', value: 100 },
    ],
    submarine: [
      { with: 'Dyson', value: 150 },
      { with: 'Rowenta', value: 100 },
      { with: 'Hoover', value: 100 },
      { with: 'Samsung', value: 100 },
      { with: 'LG', value: 100 },
      { with: 'Folletto', value: 100 },
      { with: 'Other', value: 100 },
    ],
  },
  closed: today > new Date(CAMPAIGN_END_DATE_UNIEURO),
  partner_url: 'https://www.unieuro.it/',
  logo_url: undefined,
}

export default unieuro
